var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("ConfirmationDialog2", { ref: "confirmationDialog" }),
      _vm._v(" "),
      _c("ExecutionResultsDialog", {
        ref: "rollbackResultsDialog",
        attrs: { title: "Rollback" },
        on: {
          close: function ($event) {
            return _vm.$router.push({ name: "allimports" })
          },
        },
      }),
      _vm._v(" "),
      _c(
        "SecondaryBtn",
        {
          staticClass: "ml-4",
          attrs: {
            icon: "delete_forever",
            color: "error",
            loading: _vm.loading,
            small: "",
          },
          on: {
            click: function ($event) {
              return _vm.onRollback()
            },
          },
        },
        [_vm._v("\n    " + _vm._s(_vm.$t("Button.Rollback")) + "..\n  ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }